import { Controller, Control, FieldValues, Path } from 'react-hook-form'
import CurrencyInput from 'react-currency-input-field'
import { cn } from '@/lib/utils'
import { inputVariants } from '@/app/common/components/input/inputVariants.tsx'

type ControlledCurrencyInputProps<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>
  control: Control<TFieldValues>
  id?: string
  placeholder?: string
  className?: string
  min?: number
  decimalsLimit?: number
}

export default function ControlledCurrencyInput<
  TFieldValues extends FieldValues,
>({
  name,
  control,
  id,
  placeholder = '0',
  className,
  min = 0,
  decimalsLimit = 2,
}: ControlledCurrencyInputProps<TFieldValues>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <CurrencyInput
          id={id}
          inputMode="decimal"
          min={min}
          decimalsLimit={decimalsLimit}
          className={cn(inputVariants({ variant: 'number', className }))}
          placeholder={placeholder}
          value={typeof field.value === 'number' ? field.value : 0}
          onValueChange={(value) =>
            field.onChange(value ? parseFloat(value) : 0)
          }
          onBlur={field.onBlur}
        />
      )}
    />
  )
}
